import react from 'react';
import S1_Homepage from '../Sestions/1_HomeSecs/S1_Header'
import S2_Homepage from '../Sestions/1_HomeSecs/S2_Energy'
import S3_Homepage from '../Sestions/1_HomeSecs/S3_Presence'
import S4_Homepage from '../Sestions/1_HomeSecs/S4_Message'
import S5_Homepage from '../Sestions/1_HomeSecs/S5_testimonial'

import Footer from '../Components/Footer/Footer'
import styled from "@emotion/styled";

function Home() {
  return (
    <div className="App">
      <S1_Homepage />
      <S2_Homepage />
      <S3_Homepage />
      <S4_Homepage />
      {/* <S5_Homepage /> */}
      <Footer/>
    </div>
  );
}

export default Home;
